module.exports = __webpack_public_path__ + "static/media/Question_Mark_Circle.31fa61cf.svg";